type VersionFormat = 'underscore' | 'brackets'

export const getVersionNumberFromArray = <T>(
  elementsArray: T[],
  searchProperty: keyof T,
  completeString: string,
  format: VersionFormat
): string => {
  let regex: RegExp
  let baseString: string
  let versionExtractor: (value: string) => [string, number | null]
  let nextVersion: (maxVersion: number) => string
  let maxVersion: number = 0

  switch (format) {
    case 'underscore':
      regex = new RegExp(`^(.*?_v\\d+)$`) // Capture anything followed by _v
      baseString = mapCompleteStringToBaseString(completeString, '_')
      versionExtractor = value => {
        const match = value.match(regex)
        if (match) {
          const firstSegment = match[1].split('_v').shift()
          const lastSegment = match[1].split('_v').pop()
          const versionNumber = parseInt(lastSegment!, 10)
          return [firstSegment!, isNaN(versionNumber) ? null : versionNumber]
        }
        return ['', null]
      }
      nextVersion = (maxVersion: number) => {
        return (maxVersion + 1).toString().padStart(2, '0')
      }
      break
    case 'brackets':
      regex = new RegExp(`\\((\\d+)\\)`) // Capture anything inside ()
      baseString = mapCompleteStringToBaseString(completeString, '()')
      versionExtractor = value => {
        const match = value.match(regex)
        if (match) {
          const firstSegmentMatch = value.match(new RegExp(`^(.*)\\s*\\(\\d+\\)$`))
          const firstSegment = firstSegmentMatch && firstSegmentMatch[1]
          const lastSegment = match[1]
          const versionNumber = parseInt(lastSegment!, 10)
          return [firstSegment!, isNaN(versionNumber) ? null : versionNumber]
        }
        return ['', null]
      }
      nextVersion = (maxVersion: number) => {
        return (maxVersion + 1).toString()
      }
      break
    default:
      return completeString
  }

  elementsArray.forEach(element => {
    const value = (element as any)[searchProperty]
    if (typeof value === 'string') {
      const [firstSegment, versionNumber] = versionExtractor(value)
      if (firstSegment === baseString && versionNumber !== null && versionNumber > maxVersion) {
        maxVersion = versionNumber
      }
    }
  })

  if (format === 'underscore') {
    return `${baseString}_v${nextVersion(maxVersion)}`
  }
  if (format === 'brackets') {
    const space = maxVersion === 0 ? ' ' : ''
    return `${baseString}${space}(${nextVersion(maxVersion)})`
  }
  return completeString
}

// export const getUnderscoreVersionNumberFromArray = <T>(
//   elementsArray: T[],
//   searchProperty: keyof T,
//   completeString: string
// ): string => {
//   const regex = new RegExp(`^(.*?_v\\d+)$`) // Capture anything followed by charVersionMatch
//   let maxVersion = -1
//   let baseString: string = mapCompleteStringToBaseString(completeString, '_')
//   elementsArray.forEach(element => {
//     const value = (element as any)[searchProperty]
//     if (typeof value === 'string') {
//       const match = value.match(regex)
//       if (match) {
//         const firstSegment = match[1].split('_v').shift()
//         const lastSegment = match[1].split('_v').pop()
//         const versionNumber = parseInt(lastSegment!, 10)
//         if (firstSegment === baseString && !isNaN(versionNumber) && versionNumber > maxVersion) {
//           maxVersion = versionNumber
//         }
//       }
//     }
//   })

//   const nextVersion = (maxVersion + 1).toString().padStart(2, '0')
//   return `${baseString}_v${nextVersion}`
// }

// export const getBracketsVersionNumberFromArray = <T>(
//   elementsArray: T[],
//   searchProperty: keyof T,
//   completeString: string
// ): string => {
//   const regex = new RegExp(`\\((\\d+)\\)`) // Capture number inside brackets
//   let maxVersion = 0
//   let baseString: string = mapCompleteStringToBaseString(completeString, '()')
//   elementsArray.forEach(element => {
//     const value = (element as any)[searchProperty]
//     if (typeof value === 'string') {
//       const match = value.match(regex)
//       if (match) {
//         const firstSegmentMatch = value.match(new RegExp(`^(.*)\\s*\\(\\d+\\)$`))
//         const firstSegment = firstSegmentMatch && firstSegmentMatch[1]
//         const lastSegment = match[1]
//         const versionNumber = parseInt(lastSegment!, 10)
//         if (
//           firstSegment &&
//           firstSegment === baseString &&
//           !isNaN(versionNumber) &&
//           versionNumber > maxVersion
//         ) {
//           maxVersion = versionNumber
//         }
//       }
//     }
//   })
//   const space = maxVersion === 0 ? ' ' : ''
//   const nextVersion = (maxVersion + 1).toString()
//   return `${baseString}${space}(${nextVersion})`
// }

const mapCompleteStringToBaseString = (
  completeString: string,
  charVersionMatch: '_' | '()'
): string => {
  //this function handles "codeName_vXX" when received as baseString to return "codeName"
  let regex: RegExp
  switch (charVersionMatch) {
    case '_': {
      regex = new RegExp(`^(.*?_v\\d+)$`) // Capture anything followed by _v
      const match = completeString.match(regex)
      if (match) {
        const firstSegment = match[0].split(`_v`).shift()
        return firstSegment!
      }
      break
    }
    case '()': {
      const regex = new RegExp(`^(.*)\\s*\\(\\d+\\)$`) // Capture anything before ()
      const match = completeString.match(regex)
      if (match) {
        return match[1]
      }
      break
    }
    default:
      return completeString
  }
  return completeString
}
